<template>
    <v-layout>
        <v-dialog v-model="dialog" eager max-width="600px" persistent>
            <template v-slot:activator="{ on }">
                <v-fab-transition v-if="isNew">
                    <v-btn :class="{ 'rounded-btn': true, w100: $vuetify.breakpoint.xsOnly }" v-on="on" color="info">
                        <v-icon left>person_add</v-icon>
                        {{ $t('Добавить пользователя') }}
                    </v-btn>
                </v-fab-transition>
                <v-fab-transition v-else>
                    <v-btn icon v-on="on" text class="grey--text px-0 rounded-btn" :title="$t('Редактирование пользователя')" dense>
                        <v-icon>edit</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>

            <LabeledCard :label="isNew ? $t('Добавление нового пользователя') : $t('Редактирование пользователя')">
                <v-container class="pt-5" fluid>
                    <v-form ref="userForm">
                        <v-row no-gutters dense>
                            <v-col cols="12" xs="12">
                                <v-text-field dense outlined :rules="emailRules2" label="E-mail" v-model="localDetail.email" color="gray"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters dense>
                            <v-col cols="12" xs="12">
                                <v-text-field
                                    dense
                                    outlined
                                    :rules="[rules.required]"
                                    :label="$t('Ф.И.О.')"
                                    v-model="localDetail.name"
                                    :maxlength="500"
                                    color="gray"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters dense v-show="AHOSystemShowRule">
                            <v-col cols="12" xs="12">
                                <v-autocomplete
                                    dense
                                    outlined
                                    :label="$t('Сервисная организация')"
                                    :items="itemsTranslatedServOrgs"
                                    item-text="isas_serv_org_name"
                                    item-value="isas_serv_org_rid"
                                    v-model="localDetail.isas_serv_org_rid"
                                    :rules="servOrgRule"
                                    clearable
                                    :menu-props="{ contentClass: 'users-select-menu' }"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row no-gutters dense v-show="AHSSystemShowRule">
                            <v-col cols="12" xs="12">
                                <!-- nextTick нужен при @click:clear потому что последний срабатывает до очищения значения (clearable prop) и в конце выходит undefined -->
                                <v-select
                                    dense
                                    outlined
                                    :label="$t('Категория пользователя')"
                                    :items="itemsTranslatedCategories"
                                    :rules="CategoryReqRule"
                                    item-text="category_name.category_name"
                                    item-value="record_id"
                                    v-model="localDetail.category"
                                    return-object
                                    clearable
                                    @click:clear="$nextTick(() => (localDetail.category = {}))"
                                    :menu-props="{ contentClass: 'users-select-menu' }"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-expand-transition>
                            <v-row no-gutters dense v-show="AHSSystemShowRule && localDetail.category.category_code === 'object_contract'">
                                <v-col cols="12">
                                    <SelectContractDialog v-model="localDetail.contract" ref="selectContractDialog">
                                        <v-text-field
                                            :value="localDetail.contract.contract_number"
                                            dense
                                            outlined
                                            readonly
                                            :rules="ContractsReqRule"
                                            :label="$t('Договор')"
                                            class="pointer"
                                            clearable
                                            @click:clear="clearContractSelection"
                                            :menu-props="{ contentClass: 'users-select-menu' }"
                                        ></v-text-field>
                                    </SelectContractDialog>
                                </v-col>
                            </v-row>
                        </v-expand-transition>
                        <v-expand-transition>
                            <v-row no-gutters dense v-show="AHSSystemShowRule && localDetail.category.category_code === 'house_ksk'">
                                <v-col cols="12">
                                    <SelectKSKDialog v-model="localDetail.ksk" ref="selectKSKDialog">
                                        <v-text-field
                                            :value="localDetail.ksk.isas_ksk_name"
                                            dense
                                            outlined
                                            readonly
                                            :rules="KSKReqRule"
                                            :label="$t('КСК дома')"
                                            class="pointer"
                                            clearable
                                            @click:clear="clearKSKSelection"
                                            :menu-props="{ contentClass: 'users-select-menu' }"
                                        ></v-text-field>
                                    </SelectKSKDialog>
                                </v-col>
                            </v-row>
                        </v-expand-transition>
                        <v-row
                            no-gutter
                            dense
                            v-show="
                                AHSSystemShowRule &&
                                    (localDetail.category.category_code === 'ALTS_employee' || localDetail.category.category_code === 'management')
                            "
                        >
                            <v-col cols="12" xs="12" color="gray">
                                <v-autocomplete
                                    outlined
                                    dense
                                    :label="$t('Инженер ЭР')"
                                    :items="itemsEngineer"
                                    item-text="person_ea_name_show"
                                    item-value="isas_engineer_rid"
                                    v-model="localDetail.isas_engineer_rid"
                                    clearable
                                    :menu-props="{ contentClass: 'users-select-menu' }"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row no-gutters dense>
                            <v-col cols="12" xs="12" color="gray">
                                <v-select
                                    dense
                                    outlined
                                    :rules="[rules.required]"
                                    :label="$t('Роль')"
                                    :items="availableRoles"
                                    item-text="role_name.role_name"
                                    item-value="record_id"
                                    multiple
                                    v-model="localDetail.roles_rid"
                                    :disabled="!localDetail.category.record_id"
                                    :messages="!localDetail.category.record_id ? 'Необходимо выбрать категорию' : ''"
                                    :menu-props="{ contentClass: 'users-select-menu' }"
                                    item-color="#6B7BB2"
                                >
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row dense>
                        <v-col cols="12" sm="6"></v-col>
                        <v-col cols="12" sm="3">
                            <v-btn :disabled="isUpdatingStarted" class="rounded-btn px-5" outlined color="gray" @click="dialog = false" style="width: 100%">
                                {{ $t('Закрыть') }}
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-btn
                                :disabled="isUpdatingStarted"
                                class="rounded-btn px-5"
                                :loading="isUpdatingStarted"
                                color="info"
                                depressed
                                @click="onClicksaveUser()"
                                style="width: 100%"
                            >
                                <span>{{ $t('Сохранить') }}</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </LabeledCard>
        </v-dialog>
    </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import translate from '../../utils/translate.util';
import BinCheckMixin from '../../mixins/BIN_Checker';
import FormValidator from '../../mixins/FormValidator';
import { isObjectEmpty } from '@/utils';

import LabeledCard from '../ui/LabeledCard';
import SelectKSKDialog from './SelectKSKDialog.vue';
import SelectContractDialog from './SelectContractDialog';

export default {
    props: ['isNew', 'details'],
    mixins: [BinCheckMixin, FormValidator],
    components: { LabeledCard, SelectKSKDialog, SelectContractDialog },
    data: () => ({
        dialog: false,
        isUpdatingStarted: false,
        localDetail: {
            id: null,
            email: null,
            name: null,
            isas_serv_org_rid: null,
            roles_rid: [],
            ksk: {},
            contract: {},
            category: {},
            isas_engineer_rid: null
        },
        message: null,
        messageColor: 'red'
    }),
    watch: {
        'localDetail.category': {
            async handler(category, oldCategory) {
                const isInitialValue = await isObjectEmpty(oldCategory);
                if (this.localDetail.roles_rid.length && !isInitialValue) this.localDetail.roles_rid = [];

                if (category.category_code !== 'object_contract') {
                    this.localDetail.contract = {};
                } else if (category.category_code !== 'house_ksk') {
                    this.localDetail.ksk = {};
                } else if (category.category_code !== 'ALTS_employee' && category.category_code !== 'management') {
                    this.localDetail.isas_engineer_rid = null;
                }
            },
            deep: true
        },
        async dialog() {
            this.message = null;

            if (this.dialog) {
                //очистим элементы формы
                this.$refs.userForm.resetValidation();
                if (this.isNew) {
                    this.localDetail = {
                        id: null,
                        email: null,
                        name: null,
                        isas_serv_org_rid: null,
                        roles_rid: [],
                        ksk: {},
                        contract: {},
                        category: {},
                        isas_engineer_rid: null
                    };
                    this.showServOrg = true;
                } else {
                    this.localDetail.id = this.details.record_id;
                    this.localDetail.email = this.details.email;
                    this.localDetail.name = this.details.user_data.name ? this.details.user_data.name : null;
                    this.localDetail.isas_serv_org_rid = this.details.user_data.isas_serv_org_rid ? this.details.user_data.isas_serv_org_rid : null;
                    this.localDetail.category = this.categoryList.find(x => x.record_id === this.details.user_data.category_rid) || {};

                    this.localDetail.isas_engineer_rid = this.details.user_data.isas_engineer_rid ? this.details.user_data.isas_engineer_rid : null;
                    this.localDetail.ksk = {
                        isas_ksk_rid: this.details.user_data.isas_ksk_rid,
                        isas_ksk_name: this.details.user_data.isas_ksk_name
                    };
                    this.localDetail.contract = {
                        isas_contract_rid: this.details.user_data.isas_contract_rid,
                        isas_contractor_rid: this.details.user_data.isas_contractor_rid,
                        contract_number: this.details.user_data.contract_number
                    };

                    this.localDetail.roles_rid = this.details?.roles_rid.length ? [...this.details.roles_rid] : [];
                }
            }
        }
    },
    methods: {
        ...mapActions('users', ['saveUser', 'newUser', 'getUserList']),

        clearKSKSelection() {
            this.$refs.selectKSKDialog.clearSelection();
        },

        clearContractSelection() {
            this.$refs.selectContractDialog.clearSelection();
        },

        async onClicksaveUser() {
            try {
                this.message = null;
                if (this.isUpdatingStarted) return;
                if (!this.$refs.userForm.validate()) return;

                let administrator_roles = this.roleList.filter(x => x.role_code === 'administrator');
                if (
                    administrator_roles.some(s => this.localDetail.roles_rid.includes(s.record_id)) &&
                    this.localDetail.isas_serv_org_rid &&
                    this.localDetail.isas_serv_org_rid !== null
                ) {
                    let color = 'warning';
                    let message = 'Для роли "Администратор" нельзя заполнять поле "Сервисная организация"';
                    this.$store.dispatch('base/showMessage', { color, message });
                    return;
                }
                const category = this.categoryList.find(x => x.record_id === this.localDetail.category.record_id);
                let categoryCode = '';
                if (category) {
                    categoryCode = category.category_code;
                }
                if (categoryCode !== 'house_ksk' && this.localDetail.ksk.isas_ksk_rid) {
                    let color = 'warning';
                    let message = 'Поле "КСК дома" заполняется только для категорий пользователя "КСК дома"';
                    this.$store.dispatch('base/showMessage', { color, message });
                    return;
                }
                if (categoryCode !== 'object_contract' && this.localDetail.contract.isas_contract_rid) {
                    let color = 'warning';
                    let message = 'Поле "Договор" заполняется только для категорий пользователя "Объекты договора"';
                    this.$store.dispatch('base/showMessage', { color, message });
                    return;
                }
                if (categoryCode !== 'ALTS_employee' && categoryCode !== 'management' && this.localDetail.isas_engineer_rid) {
                    let color = 'warning';
                    let message = 'Поле "Инженер" заполняется только для категорий пользователя "Сотрудник ТОО «АлТС»", "Руководство"';
                    this.$store.dispatch('base/showMessage', { color, message });
                    return;
                }

                let categoryRoles_rid = [];
                let notExist = false;
                categoryRoles_rid = this.rolesCategoryList.filter(x => x.category_rid === this.localDetail.category.record_id).map(s => s.role_rid);

                for (let i = 0; i < this.localDetail.roles_rid.length; i++) {
                    notExist = !categoryRoles_rid.includes(this.localDetail.roles_rid[i]);
                    if (notExist) break;
                }
                if (notExist) {
                    let color = 'warning';
                    let message = 'Неправильное сочетание категории пользователя и ролей';
                    this.$store.dispatch('base/showMessage', { color, message });
                    return;
                }

                const selectedRoles = this.roleList.filter(role => this.localDetail.roles_rid.includes(role.record_id));

                const selectedRoleCodes = selectedRoles.map(role => role.role_code);

                // ===========================новый запрет на одновремменное использование ролей====================
                if (categoryCode === 'management') {
                    const hasAdminOzp = selectedRoleCodes.includes('admin_ozp');
                    const hasInspector = selectedRoleCodes.includes('management_ozp');
          
                    if (hasAdminOzp && hasInspector) {
                        this.$store.dispatch('base/showMessage', {
                            color: 'warning',
                            message: 'Для категории "Руководство" нельзя одновременно выбирать роли "Администратор ОЗП" и "Инспектор"'
                        });
                        return;
                    }
                }

                if (categoryCode === 'ALTS_employee') {
                    const conflictRoles = selectedRoleCodes.filter(
                        code =>
                            code.includes('engineer_ozp') ||
                            //code.includes('boss_tsop_ozp') ||
                            code.includes('req_contract_set') ||
                            code.includes('req_contract_exec') ||
                            code.includes('req_pute_set') ||
                            code.includes('req_pute_exec') ||
                            code.includes('administrator_ahs')
                    );

                    if (conflictRoles.length > 1) {
                        this.$store.dispatch('base/showMessage', {
                            color: 'warning',
                            message:
                                'Для категории "Сотрудник ТОО «АлТС»" нельзя одновременно выбирать роли "Инженер", "Руководитель ЦОП", "ОД. Назначение заявок на продление договора", "ОД. Исполнение заявок на продление договора", "ОР. Назначение заявок на расчет дроссельного устройства", "ОР. Исполнение заявок на расчет дроссельного устройства" и "Администратор. AHS"'
                        });
                        return;
                    }
                }
                //=============================================================================================================================

                if (!this.isNew) {
                    let res = await this.saveUser({
                        user_id: this.localDetail.id,
                        email: this.localDetail.email,
                        name: this.localDetail.name,
                        isas_serv_org_rid: this.localDetail.isas_serv_org_rid,
                        roles_rid: this.localDetail.roles_rid,
                        isas_ksk_rid: this.localDetail.ksk.isas_ksk_rid,
                        isas_contract_rid: this.localDetail.contract.isas_contract_rid,
                        category_rid: this.localDetail.category.record_id,
                        isas_engineer_rid: this.localDetail.isas_engineer_rid,
                        isas_contractor_rid: this.localDetail.contract.isas_contractor_rid
                    });
                    if (res && res.successfull) {
                        this.dialog = false;
                    }
                } else {
                    let res = await this.newUser({
                        email: this.localDetail.email,
                        name: this.localDetail.name,
                        isas_serv_org_rid: this.localDetail.isas_serv_org_rid,
                        roles_rid: this.localDetail.roles_rid,
                        isas_ksk_rid: this.localDetail.ksk.isas_ksk_rid,
                        isas_contract_rid: this.localDetail.contract.isas_contract_rid,
                        category_rid: this.localDetail.category.record_id,
                        isas_engineer_rid: this.localDetail.isas_engineer_rid,
                        isas_contractor_rid: this.localDetail.contract.isas_contractor_rid
                    });
                    if (res && res.successfull) {
                        this.dialog = false;
                        let color = 'success';
                        let message = this.$t('Пользователь добавлен. На почту отправлена ссылка для установки пароля');
                        this.$store.dispatch('base/showMessage', { color, message });
                    }
                }
                await this.getUserList();
            } finally {
                this.isUpdatingStarted = false;
            }
        }
    },
    computed: {
        ...mapState('users', ['servOrgList', 'roleList', 'selectedUser', 'contractList', 'kskList', 'categoryList', 'rolesCategoryList', 'itemsEngineer']),
        ...mapState('permissions', ['userPermissions']),

        itemsTranslatedServOrgs() {
            const so = translate(this.servOrgList, 'full', this.$i18n.locale);
            so.sort((a, b) => a.isas_serv_org_name.localeCompare(b.isas_serv_org_name));
            return so;
        },
        itemsTranslatedRoles() {
            let arr = [];
            if (this.userPermissions.some(x => x === 'system_ahs')) arr.push('ahs');
            if (this.userPermissions.some(x => x === 'system_aho')) arr.push('aho');
            let roles = translate(
                this.roleList.filter(c => arr.includes(c.role_group)),
                'full',
                this.$i18n.locale
            );
            roles.sort((a, b) => a.role_name.role_name.localeCompare(b.role_name.role_name));
            return roles;
        },
        availableRoles() {
            switch (this.localDetail.category.category_code) {
                case 'object_contract':
                case 'house_ksk':
                    return this.itemsTranslatedRoles.filter(role => role.role_code.includes('consumer'));
                case 'ALTS_employee':
                    return this.itemsTranslatedRoles.filter(
                        role => role.role_code.includes('engineer') || role.role_code.includes('administrator') || role.role_code.includes('req_') //||
                        //role.role_code.includes('boss_tsop_')
                    );
                case 'management':
                    return this.itemsTranslatedRoles.filter(
                        role => role.role_code.includes('management') || role.role_code.includes('admin_ozp')
                    );
                default:
                    break;
            }

            return [];
        },
        itemsContracts() {
            const contracts = translate(this.contractList, 'full', this.$i18n.locale);
            //contracts.sort((a, b) => a.contract_number.localeCompare(b.contract_number));
            return contracts;
        },
        // itemsTranslatedKSK() {
        //     const ksk = translate(this.kskList, 'full', this.$i18n.locale);
        //     ksk.sort((a, b) => a.isas_ksk_name.localeCompare(b.isas_ksk_name));
        //     return ksk;
        // },
        itemsTranslatedCategories() {
            let categories = translate(this.categoryList, 'full', this.$i18n.locale);
            categories.sort((a, b) => a.category_name.category_name.localeCompare(b.category_name.category_name));
            return categories;
        },
        servOrgRule: function(v) {
            let serv_org_roles = this.roleList.filter(x => x.role_code === 'serv_org_view' || x.role_code === 'serv_org_indications');
            let req = false;
            if (
                serv_org_roles.some(s => this.localDetail.roles_rid.includes(s.record_id)) &&
                (!this.localDetail.isas_serv_org_rid || this.localDetail.isas_serv_org_rid === 0)
            ) {
                req = true;
            }

            return [v => !req || this.$t('Обязательное поле')];
        },
        userRoleRule: function(v) {
            let serv_org_roles = this.roleList.filter(x => x.role_code === 'serv_org_view' || x.role_code === 'serv_org_indications');
            let req = false;
            if (
                serv_org_roles.some(s => this.localDetail.roles_rid.includes(s.record_id)) &&
                (!this.localDetail.isas_serv_org_rid || this.localDetail.isas_serv_org_rid === 0)
            ) {
                req = true;
            }

            return [v => !req || this.$t('Обязательное поле')];
        },
        CategoryReqRule: function(v) {
            let ahs = this.userPermissions.some(x => x === 'system_ahs');
            let req = false;
            if (ahs && (!this.localDetail.category.record_id || this.localDetail.category.record_id === 0)) {
                req = true;
            }
            return [v => !req || this.$t('Обязательное поле')];
        },
        ContractsReqRule: function(v) {
            const category = this.categoryList.find(x => x.record_id === this.localDetail.category.record_id);
            let categoryCode = '';
            if (category) {
                categoryCode = category.category_code;
            }

            let req = false;
            if (categoryCode === 'object_contract' && (!this.localDetail.contract.isas_contract_rid || this.localDetail.contract.isas_contract_rid === 0)) {
                req = true;
            }
            return [v => !req || this.$t('Обязательное поле')];
        },
        KSKReqRule: function(v) {
            const category = this.categoryList.find(x => x.record_id === this.localDetail.category.record_id);
            let categoryCode = '';
            if (category) {
                categoryCode = category.category_code;
            }

            let req = false;
            if (categoryCode === 'house_ksk' && (!this.localDetail.ksk.isas_ksk_rid || this.localDetail.ksk.isas_ksk_rid === 0)) {
                req = true;
            }
            return [v => !req || this.$t('Обязательное поле')];
        } /*,
        isKSKDisable: function(v){
            const category = this.categoryList.find(x => x.record_id === this.localDetail.category_rid);
            let categoryCode = '';
            if (category) {
                categoryCode = category.category_code;
            }
            return categoryCode !== 'house_ksk';
        },
        isContractDisable: function(v){
            const category = this.categoryList.find(x => x.record_id === this.localDetail.category_rid);
            let categoryCode = '';
            if (category) {
                categoryCode = category.category_code;
            }
            return categoryCode !== 'object_contract';
        }*/,
        AHSSystemShowRule: function(v) {
            let show = this.userPermissions.some(x => x === 'system_ahs');
            return show;
        },
        AHOSystemShowRule: function(v) {
            let show = this.userPermissions.some(x => x === 'system_aho');
            return show;
        },
        EngReqRule: function(v) {
            const category = this.categoryList.find(x => x.record_id === this.localDetail.category.record_id);
            let categoryCode = category ? category.category_code : '';
            let req = categoryCode === 'ALTS_employee' && (!this.localDetail.isas_engineer_rid || this.localDetail.isas_engineer_rid === 0) ? true : false;

            return [v => !req || this.$t('Обязательное поле')];
        }
    }
};
</script>

<style>
.edit-header {
    background-color: #363e59;
    height: 40px;
}
.users-select-menu .v-list-item--active {
    background-color: #e6ecff !important;
}
.users-select-menu .v-list-item--active .v-list-item__title,
.users-select-menu .v-list-item--active .v-list-item__content {
    color: #1f2d5a !important;
    font-weight: 600;
}
</style>
